import { WidgetDefinition } from '../models/WidgetDefinition';

export const textWidgetDefinition: WidgetDefinition = {
    baseType: 'text',
    group: 'Others',
    highlights: ['A free text input', 'Can also be used to create titles'],
    icon: 'fa-file-text-o',
    sortingOrder: 1800,
    title: 'Text',
    type: 'text'
};